import { h, Component } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';
import { getOrderTotalPrice } from 'store/updateTicketing';
import { getCopy } from 'utils/copy';
import { accessNested, joinClasses } from 'utils/utils';
import { track } from 'utils/tracking';
import s from 'components/shared/theaters/ticketing/ticketContactDetails/ticketContactDetails.sss';
import bb from 'components/shared/theaters/ticketing/bottomBar.sss';


const EMAIL_REGEXP = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

const checkEmailField = ($input) => {
	const email = $input.value.trim();

	if (!EMAIL_REGEXP.test(email)) {
		Store.emit(actions.SET_TICKETING_MESSAGE, {
			message: getCopy('EMAIL_IS_NOT_VALID'),
			callback: () => { $input.focus(); }
		});
		return false;
	}

	return true;
};

const checkTextField = (name, $input, required, minLen, maxLen) => {
	const value = $input.value.trim();

	if (value.length === 0) {
		if (required) {
			Store.emit(actions.SET_TICKETING_MESSAGE, {
				message: getCopy('FIELD_IS_EMPTY', { FIELD: name }),
				callback: () => { $input.focus(); }
			});
			return false;
		} else return true;
	}

	if (minLen && value.length < minLen) {
		Store.emit(actions.SET_TICKETING_MESSAGE, {
			message: getCopy('FIELD_IS_TOO_SHORT', { FIELD: name }),
			callback: () => { $input.focus(); }
		});
		return false;
	} else if (maxLen && value.length > maxLen) {
		Store.emit(actions.SET_TICKETING_MESSAGE, {
			message: getCopy('FIELD_IS_TOO_LONG', { FIELD: name }),
			callback: () => { $input.focus(); }
		});
		return false;
	}

	return true;
};


/**
 * This component is a form asking for client info (name, email, billing address and zip code)
 * required by payment gateways to generate the payment iframe.
 */
export default class TicketContactDetails extends Component {

	constructor(props) {
		super(props);

		this.state = {
			useLoyalty:  false,
			legalsAccepted: false
		};

		this.loyaltyInputTrackEventSent = false;

		this.onLoyaltyCheckboxClick = this.onLoyaltyCheckboxClick.bind(this);
		this.onLoyaltyInput = this.onLoyaltyInput.bind(this);
		this.onLegalsCheckboxClick = this.onLegalsCheckboxClick.bind(this);
		this.goToNext = this.goToNext.bind(this);
	}

	onLoyaltyCheckboxClick() {
		if (this.state.useLoyalty !== this.$loyaltyCheckbox.checked) {
			this.setState({ useLoyalty: this.$loyaltyCheckbox.checked });
			track({ a: this.$loyaltyCheckbox.checked ? 'ticketing-loyalty-activate' : 'ticketing-loyalty-deactivate' });
		}
	}

	onLoyaltyInput() {
		if (!this.loyaltyInputTrackEventSent) {
			track({ a: 'ticketing-loyalty-input' });
			this.loyaltyInputTrackEventSent = true;
		}
	}

	onLegalsCheckboxClick() {
		if (this.state.legalsAccepted !== this.$legalsCheckbox.checked) {
			this.setState({ legalsAccepted: this.$legalsCheckbox.checked });
		}
	}

	goToNext(event) {
		event.preventDefault();

		if (!this.isFormValid()) return;

		const { ticketing } = this.props;
		const { contactFields } = this.props.ticketing;

		const contactDetails = {
			email: this.$emailInput.value.trim(),
		};

		if (contactFields.name) {
			const nameParts = [
				this.$firstNameInput.value.trim(),
				this.$lastNameInput.value.trim()
			];
			contactDetails.name = nameParts.filter(e => e).join(' ');
		}

		if (contactFields.phone) {
			contactDetails.phone = this.$phoneInput.value.trim();
		}

		if (ticketing.loyaltyEnabled && this.state.useLoyalty) {
			contactDetails.loyaltyNumber = this.$loyaltyInput.value.trim();
		}

		Store.emit(actions.GO_TICKETING_PAYMENT, contactDetails);
	}

	/**
	 * Basic font-side validation.
	 *
	 * @return {boolean} true if input values are valid, false otherwise.
	 */
	isFormValid() {
		//if (!this.$nameInput || !this.$emailInput || !this.$addressInput || !this.$zipInput || !this.$cityInput || !this.$legalsCheckbox) {
		if (!this.$emailInput || !this.$legalsCheckbox) {
			console.error('Some input ref are not available yet');
			// Store.emit(actions.SET_TICKETING_MESSAGE, { message: 'Not ready yet' });
			return false;
		}

		if (!this.$legalsCheckbox.checked) {
			Store.emit(actions.SET_TICKETING_MESSAGE, {
				message: 'You have to agree with the theater\'s terms & conditions', // TODO: Copy here
				callback: () => { this.$legalsCheckbox.focus(); }
			});
			return false;
		}

		const { contactFields } = this.props.ticketing;

		if (contactFields.name) {
			if (!checkTextField(getCopy('FIRST_NAME'), this.$firstNameInput, true, 1, 72)) return false;
			if (!checkTextField(getCopy('LAST_NAME'), this.$lastNameInput, true, 1, 72)) return false;
		}
		if (!checkEmailField(this.$emailInput)) return false;
		if (contactFields.phone) {
			if (!checkTextField(getCopy('PHONE_NUMBER'), this.$phoneInput, true, 5, 30)) return false;
		}
		// if (!checkTextField(getCopy('ADDRESS'), this.$addressInput, false, 3, 180)) return false;
		// if (!checkTextField(getCopy('ZIP_CODE'), this.$zipInput, false, 3, 24)) return false;
		// if (!checkTextField(getCopy('CITY'), this.$cityInput, false, 0, 80)) return false;
		if (this.props.ticketing.loyaltyEnabled && this.state.useLoyalty) {
			if (!checkTextField(getCopy('LOYALTY_NUMBER'), this.$loyaltyInput, true)) return false;
		}

		return true;
	}

	renderLoyaltyForm(props, { useLoyalty }) {
		return [
			(
				<p key="loyaltyCheckbox" class={s.formLoyaltyRow}>
					<input id="loyaltyCheckbox" type="checkbox" checked={useLoyalty} onClick={this.onLoyaltyCheckboxClick} ref={$ref => this.$loyaltyCheckbox = $ref} />
					<label for="loyaltyCheckbox">{getCopy('I_HAVE_A_LOYALTY_CARD')}</label>
				</p>
			),
			useLoyalty && (
				<p key="loyaltyInput" class={s.formRow}>
					<input placeholder={getCopy('LOYALTY_NUMBER')} onInput={this.onLoyaltyInput} ref={$ref => this.$loyaltyInput = $ref} />
				</p>
			)
		];
	}

	render(props, { legalsAccepted }) {
		const {
			ticketing, // Object - the ticketing state
			currencyCopy = 'CURRENCY'
		} = props;

		const { contactFields } = ticketing;

		const termsUrl     = accessNested(ticketing, 'meta.termsUrl');
		const termsOwner   = accessNested(ticketing, 'meta.termsOwner');
		const privacyUrl   = accessNested(ticketing, 'meta.privacyUrl');
		const privacyOwner = accessNested(ticketing, 'meta.privacyOwner');

		let legals;
		if (termsUrl && !privacyUrl) {
			legals = <a target="_blank" href={termsUrl}>{termsOwner} {getCopy('TERMS')}</a>;
		} else if (privacyUrl && !termsUrl) {
			legals = <a target="_blank" href={privacyUrl}>{privacyOwner} {getCopy('PRIVACY')}</a>;
		} else if (termsUrl === privacyUrl) {
			legals = <a target="_blank" href={termsUrl}>{termsOwner || privacyOwner} {getCopy('TERMS')} &amp; {getCopy('PRIVACY')}</a>;
		} else {
			legals = [<a target="_blank" href={termsUrl}>{termsOwner} {getCopy('TERMS')}</a>, ' and ', <a target="_blank" href={privacyUrl}>{privacyOwner} {getCopy('PRIVACY')}</a>];
		}
		// TODO: ^ We'll have to change that later, for better localisation

		return (
			<form onSubmit={this.goToNext} class={joinClasses(props.class, s.stepContainer)}>
				<h1 class={s.header}>{getCopy('WHAT_CONTACT_DETAILS')}</h1>
				<div class={s.formContainer}>
					{contactFields.name && <p key="firstName" class={s.formRow}><input placeholder={getCopy('FIRST_NAME') + '*'} ref={$ref => this.$firstNameInput = $ref} /></p>}
					{contactFields.name && <p key="lastName" class={s.formRow}><input placeholder={getCopy('LAST_NAME') + '*'} ref={$ref => this.$lastNameInput = $ref} /></p>}
					<p key="email" class={s.formRow}><input type='email' required placeholder={getCopy('EMAIL') + '*'} ref={$ref => this.$emailInput = $ref} /></p>
					{contactFields.phone && <p key="phone" class={s.formRow}><input placeholder={getCopy('PHONE_NUMBER') + '*'} ref={$ref => this.$phoneInput = $ref} /></p>}
					{/*contactFields.address && <p key="address" class={s.formRow}><input placeholder={getCopy('ADDRESS')} ref={$ref => this.$addressInput = $ref} /></p>*/}
					{/*contactFields.zip && <p key="zip" class={s.formRow}><input placeholder={getCopy('ZIP_CODE')} ref={$ref => this.$zipInput = $ref} /></p>*/}
					{/*contactFields.city && <p key="city" class={s.formRow}><input placeholder={getCopy('CITY')} ref={$ref => this.$cityInput = $ref} /></p>*/}
					{ticketing.loyaltyEnabled && this.renderLoyaltyForm(props, this.state)}
					<p key="legals" class={s.formLegalsRow}>
						<input id="legalsCheckbox" type="checkbox" checked={legalsAccepted} required onClick={this.onLegalsCheckboxClick} ref={$ref => this.$legalsCheckbox = $ref} />
						<label for="legalsCheckbox"> {getCopy('I_AGREE_WITH')} {legals}</label>
					</p>
				</div>
				<div class={bb.wrapper}>
					<div class={bb.info}>
						<div class={bb.total}>
							{getCopy('TOTAL', {}, 'Total')}
							<span class={bb.totalAmount}>{getCopy(currencyCopy, { value: getOrderTotalPrice(ticketing) })}</span>
						</div>
					</div>
					<div class={bb.buttonWrapper}>
						<button class={bb.button} onClick={this.goToNext} disabled={!legalsAccepted} style={{ maxWidth: '155px' }}>{getCopy('RESERVE')}</button>
					</div>
				</div>
			</form>
		);
	}

}
